import { render } from "./ConfirmDeleteModal.html?vue&type=template&id=8cd3243a&scoped=true"
import script from "./ConfirmDeleteModal.js?vue&type=script&lang=js"
export * from "./ConfirmDeleteModal.js?vue&type=script&lang=js"

import "./ConfirmDeleteModal.css?vue&type=style&index=0&id=8cd3243a&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-admin-portal/src/ST.PetroNetworkAdmin.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cd3243a"]])

export default __exports__